// Module
var code = `<template>
  <mdc-dialog view-model.ref="dialog">
    <mdc-dialog-title>Add Company</mdc-dialog-title>
    <mdc-dialog-content>
      <div mdc-menu-surface-anchor style="width: 100%; min-width: 400px; min-height: 200px;">
        <mdc-text-field ref="input" label="Select Company" style="width: 100%;"></mdc-text-field>
        <mdc-lookup options.bind="getOptions" value.bind="model.selectedId" input.bind="input" display-field="name" value-field="id" debounce="300" preload-options hoist-to-body natural-width>
        </mdc-lookup>
      </div>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button click.trigger="dialog.close('cancel')">Cancel</button>
      <button mdc-button click.trigger="dialog.close('ok')" disabled.bind="!model.selectedId">Add</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;